import { Typography } from "@mui/material";

export function CameraOverlayDataComposer({ data }: { data: any }) {
  return (
    <div style={{ padding: '10px' }} >
      {Object.keys(data).map(k =>
        <div key={k}><Typography color='error' variant='h6'>{k}: {data[k]}</Typography></div>
      )}
    </div>
  );
}